module.exports = __webpack_public_path__ + "img/nunito-sans-v11-latin-200.c66af3e7.svg";